import React, { Component } from 'react';

//Custom Components
import Header from '../components/Header'

// Third Party
import Lottie from 'react-lottie';

// Images
import underMaintenance from '../img/under-maintenance.json'


class Games extends Component {

  render() {
    return (
      <div
        className="align-items-center"
      >
      <Header
        title="Games"
      />

    <Lottie 
        height={220}
        style={styles.construction}
        options={{
            loop: true,
            autoplay: true, 
            animationData: underMaintenance,
            rendererSettings: {
                
            },
        }}
    />
      <h4>This page is currently in development</h4>
      </div>
    );
  }
}

const styles = {
  construction: {
    marginTop: "10%"
  }
}

export default Games;



// WEBPACK FOOTER //
// ./src/screens/Games.js